import { render, staticRenderFns } from "./cv-checkbox.vue?vue&type=template&id=2cb57f98&"
import script from "./cv-checkbox.vue?vue&type=script&lang=js&"
export * from "./cv-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports